import { Dispatch, SetStateAction, createContext } from 'react';

import { CardType } from './logic';

export interface CardContentContextType {
  cardType?: CardType;
  displaySubtitleOnSmallDevice?: boolean;
  hasSubtitleHover?: boolean;
  isHovered?: boolean;
  hasTags?: boolean;
  setHasTags?: Dispatch<SetStateAction<boolean>>;
  hasLogo?: boolean;
  setHasLogo?: Dispatch<SetStateAction<boolean>>;
}

const CardContentContext = createContext<CardContentContextType>({});

export default CardContentContext;
